import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import TopNav from '@/components/navigation/TopNav';
import MobileBottomTab from '@/components/navigation/MobileBottomTab';
import AskSFab from '@/components/ai/AskSFab';
import Footer from '@/components/layout/Footer';
import PoweredBy from '@/components/tenant/PoweredBy';   // r7.6 fixed line on the footer-less auth screens too
import NativeUpdateBanner from '@/components/tenant/NativeUpdateBanner';   // r7.6 step 9 (native shell only)
import { useVerticalAccent } from '@/hooks/useVerticalAccent';

/**
 * Top-level shell. Renders nav + outlet + footer + AI fab + mobile tab.
 *
 * Adds bottom padding on mobile so content isn't hidden behind the bottom tab.
 * Applies per-vertical accent override (admin-controlled).
 */
export default function AppLayout() {
  const router = useLocation();
  useVerticalAccent();  // sets --snt-vertical-accent based on route + admin config

  // Hide footer + bottom-tab on auth flows for a more focused experience
  const isAuth = ['/login', '/signup', '/forgot-password'].includes(router.pathname);

  return (
    <div className="min-h-dvh flex flex-col">
      <TopNav />
      <NativeUpdateBanner />

      <main className="flex-1 pb-[68px] lg:pb-0">
        <Outlet />
      </main>

      {!isAuth && <Footer />}
      {isAuth && <div className="px-6 pb-6 pt-2 text-center"><PoweredBy /></div>}
      {!isAuth && <MobileBottomTab />}
      <AskSFab />
    </div>
  );
}
